'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _clauses = require('../actions/clauses');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchClauses),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchClause),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(createClause),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(editClause),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteClause),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(extractClause),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(fetchClausesRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(fetchClauseRequest),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(createClauseRequest),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(editClauseRequest),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(deleteClauseRequest),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(extractClauseRequest);

function fetchClauses(_ref) {
    var lawId = _ref.lawId;
    var response;
    return regeneratorRuntime.wrap(function fetchClauses$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/clauses', { lawId: lawId });

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_clauses.actionCreators.fetchClausesSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_clauses.actionCreators.fetchClausesFailed(_context.t0));

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchClause(_ref2) {
    var id = _ref2.id;
    var response;
    return regeneratorRuntime.wrap(function fetchClause$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/clauses/' + id);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_clauses.actionCreators.fetchClauseSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_clauses.actionCreators.fetchClauseFailed(_context2.t0));

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function createClause(_ref3) {
    var clause = _ref3.clause,
        onSuccess = _ref3.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function createClause$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/clauses', clause);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_clauses.actionCreators.createClauseSucceeded(response.data));

                case 6:
                    if (onSuccess) onSuccess();
                    _context3.next = 13;
                    break;

                case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 13;
                    return (0, _effects.put)(_clauses.actionCreators.createClauseFailed(_context3.t0.response ? _context3.t0.response.data : _context3.t0));

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 9]]);
}

function editClause(_ref4) {
    var clause = _ref4.clause,
        onSuccess = _ref4.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function editClause$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/clauses/' + clause.id, clause);

                case 3:
                    response = _context4.sent;
                    _context4.next = 6;
                    return (0, _effects.put)(_clauses.actionCreators.editClauseSucceeded(response.data));

                case 6:
                    if (onSuccess) onSuccess();
                    _context4.next = 13;
                    break;

                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 13;
                    return (0, _effects.put)(_clauses.actionCreators.editClauseFailed(_context4.t0.response ? _context4.t0.response.data : _context4.t0));

                case 13:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 9]]);
}

function deleteClause(_ref5) {
    var id = _ref5.id;
    return regeneratorRuntime.wrap(function deleteClause$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'delete', '/clauses/' + id);

                case 3:
                    _context5.next = 5;
                    return (0, _effects.put)(_clauses.actionCreators.deleteClauseSucceeded(id));

                case 5:
                    _context5.next = 11;
                    break;

                case 7:
                    _context5.prev = 7;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 11;
                    return (0, _effects.put)(_clauses.actionCreators.deleteClauseFailed(_context5.t0.response ? _context5.t0.response.data : _context5.t0));

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 7]]);
}

function extractClause(_ref6) {
    var rawText = _ref6.rawText;
    var response;
    return regeneratorRuntime.wrap(function extractClause$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.prev = 0;
                    _context6.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/clauses/extract', { rawText: rawText });

                case 3:
                    response = _context6.sent;
                    _context6.next = 6;
                    return (0, _effects.put)(_clauses.actionCreators.extractClauseSucceeded(response.data));

                case 6:
                    _context6.next = 12;
                    break;

                case 8:
                    _context6.prev = 8;
                    _context6.t0 = _context6['catch'](0);
                    _context6.next = 12;
                    return (0, _effects.put)(_clauses.actionCreators.extractClauseFailed(_context6.t0.response ? _context6.t0.response.data : _context6.t0));

                case 12:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this, [[0, 8]]);
}

function fetchClausesRequest() {
    return regeneratorRuntime.wrap(function fetchClausesRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_clauses.actionTypes.FETCH_CLAUSES_REQUEST, fetchClauses);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function fetchClauseRequest() {
    return regeneratorRuntime.wrap(function fetchClauseRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_clauses.actionTypes.FETCH_CLAUSE_REQUEST, fetchClause);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function createClauseRequest() {
    return regeneratorRuntime.wrap(function createClauseRequest$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(_clauses.actionTypes.CREATE_CLAUSE_REQUEST, createClause);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function editClauseRequest() {
    return regeneratorRuntime.wrap(function editClauseRequest$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(_clauses.actionTypes.EDIT_CLAUSE_REQUEST, editClause);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function deleteClauseRequest() {
    return regeneratorRuntime.wrap(function deleteClauseRequest$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return (0, _effects.takeLatest)(_clauses.actionTypes.DELETE_CLAUSE_REQUEST, deleteClause);

                case 2:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function extractClauseRequest() {
    return regeneratorRuntime.wrap(function extractClauseRequest$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(_clauses.actionTypes.EXTRACT_CLAUSE_REQUEST, extractClause);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

exports.default = [fetchClausesRequest, fetchClauseRequest, createClauseRequest, editClauseRequest, deleteClauseRequest, extractClauseRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/clauses.js
// module id = 2137
// module chunks = 0